<template>
  <div>
    <v-row v-if="!onlyview">
      <v-col>
        <FormTags
          :disabled="onlyview || disabled || loading || localLoading"
          :placeholder="'Pesquise e selecione o produto'"
          :label="'Produto'"
          v-model="selecionado"
          :endpoint="endpointProdutos"
          queryname="search"
          :searchWithSpaces="true"
          keyid="idcadastroextraproduto"
          keyvalue="nome_pesquisa"
          :multiple="false"
          :clearable="true"
          @change="buscarPreco"
        >
          <template v-slot:item="{ item }">
            <div class="d-flex flex-column align-start">
              <p style="margin-bottom:0!important">{{ item.nome }}</p>
              <small v-if="item.id_produto_erp"
                >Cód. interno: {{ item.id_produto_erp }}</small
              >
              <small v-if="item.codigobarras"
                >Cód. barras:{{ item.codigobarras }}</small
              >
            </div>
          </template>
        </FormTags>
      </v-col>
      <v-col cols="auto" v-if="!onlyview && !disabled">
        <FormButton
          :disabled="loading || localLoading"
          @click="abrirBuscaAvancada"
          type="primario"
        >
          Pesquisa avançada
        </FormButton>
      </v-col>
    </v-row>
    <v-row v-if="!onlyview">
      <v-col cols="12" md="auto">
        <FormField
          class="input-text"
          label="Preço Unitário R$"
          v-model="preco_unitario"
          :disabled="disabled || loading || localLoading || produtoIndisponivel"
          readonly
          typeField="number"
        />
      </v-col>
      <v-col cols="12" md="auto">
        <FormField
          class="input-text"
          label="Múltiplo"
          v-model="multiplo_incremento"
          :disabled="disabled || loading || localLoading || produtoIndisponivel"
          readonly
          typeField="number"
        />
      </v-col>
      <v-col cols="12" md="auto">
        <FormField
          class="input-text"
          label="Quantidade"
          v-model="quantidade"
          :disabled="disabled || loading || localLoading || produtoIndisponivel"
          @input="handlerInput"
          typeField="number"
        />
      </v-col>
      <v-col cols="12" md="auto">
        <FormField
          class="input-text"
          label="Preço R$"
          v-model="preco"
          :disabled="disabled || loading || localLoading || produtoIndisponivel"
          @blur="blurPreco"
          typeField="number"
        />
      </v-col>
      <v-col cols="12" md="auto">
        <FormField
          class="input-text"
          label="Preço Tabela R$"
          v-model="preco_original"
          :disabled="disabled || loading || localLoading || produtoIndisponivel"
          readonly
          typeField="number"
        />
      </v-col>
      <v-col cols="12" md="auto">
        <FormField
          class="input-text"
          label="Preço E-commerce R$"
          v-model="preconf"
          :disabled="disabled || loading || localLoading || produtoIndisponivel"
          readonly
          typeField="number"
        />
      </v-col>
      <v-col cols="12" md="auto">
        <FormField
          class="input-text"
          label="Menor Preço R$"
          v-model="preco_minimo"
          :disabled="disabled || loading || localLoading || produtoIndisponivel"
          readonly
          typeField="number"
        />
      </v-col>
      <v-spacer />
      <v-col cols="12" md="auto">
        <FormButton
          @click="adicionarProduto"
          type="success"
          :disabled="
            !selecionado ||
              disabled ||
              loading ||
              localLoading ||
              produtoIndisponivel
          "
        >
          Adicionar
        </FormButton>
      </v-col>
      <v-spacer />
    </v-row>
    <v-alert v-if="produtoIndisponivel" type="error" class="ma-0 mt-n4">
      Produto indisponível
    </v-alert>
    <v-simple-table v-if="value && value.length > 0">
      <thead>
        <tr>
          <th>Nome do produto</th>
          <th>Unitário</th>
          <th>Múltiplo</th>
          <th>Qtd</th>
          <th>Preço</th>
          <th>Tabela</th>
          <th>E-commerce</th>
          <th>Menor Preço</th>
          <th>Desconto</th>
          <th>Subtotal</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="produto in produtosOrdenados" :key="produto.id">
          <td>
            <v-row>
              <v-col cols="auto">
                <v-icon
                  color="error"
                  size="14"
                  @click="removeProduct(produto.id)"
                  v-if="!onlyview"
                >
                  fa-trash
                </v-icon>
              </v-col>
              <v-col>
                <div v-if="produto.idcombopromocional_cabecalho">
                  <span @click="buscarImagemCombo(produto)" v-if="!onlyview">{{
                    produto.nome_combo
                  }}</span>
                  <span v-else>{{ produto.nome_combo }}</span>
                  <span
                    data-toggle="tooltip"
                    title="Este produto é um Combo Promocional"
                  >
                    <i class="fas fa-copyright"></i>
                  </span>
                </div>
                <div v-else>
                  <span
                    @click="
                      buscarProduto(
                        produto.idproduto,
                        produto.idcadastroextraproduto
                      )
                    "
                    v-if="!onlyview"
                  >
                    {{ produto.nome }}
                  </span>
                  <span v-else>{{ produto.nome }}</span>
                </div>
              </v-col>
            </v-row>
          </td>
          <td v-if="produto.idcombopromocional_cabecalho">
            {{ produto.preco | formatMoney }}
          </td>
          <td v-else>
            {{
              prodUsaAtacado(produto)
                ? produto.preco_sem_politica_atacado /
                  produto.multiploincremento
                : produto.preco_original | formatMoney
            }}
          </td>
          <td>{{ produto.multiploincremento || 1 }}</td>
          <td v-if="!onlyview">
            <FormField
              class="mb-n5 mt-2"
              v-model="produto.quantidade"
              :disabled="
                produto.idcombopromocional_cabecalho ||
                  onlyview ||
                  loading ||
                  localLoading
              "
              typeField="number"
              @blur="granularidadeProduto(produto), handlerInput(produto, true)"
              :label="produto.labelunidade ? produto.labelunidade : 'Qtd'"
            />
          </td>
          <td v-else>{{ produto.quantidade }}</td>
          <td v-if="!onlyview">
            <FormField
              class="mb-n5 mt-2"
              :value="precoProduto(produto)"
              @blur="
                setPrecoAtendente(produto, $event), updatePrecoProduto(produto)
              "
              :disabled="
                produto.idcombopromocional_cabecalho ||
                  onlyview ||
                  loading ||
                  localLoading
              "
              label="Preço"
              typeField="number"
            />
          </td>
          <td v-else>
            {{ produto.precoatendente | formatMoney }}
          </td>
          <td>
            <div v-if="produto.idcombopromocional_cabecalho">
              {{ produto.preco | formatMoney }}
            </div>
            <div v-else>
              {{
                prodUsaAtacado(produto)
                  ? produto.preco_sem_politica_atacado
                  : produto.preco_sem_politica_varejo ||
                    (produto.preco_original *
                      (produto.multiploincremento || 1))
                      | formatMoney
              }}
            </div>
          </td>
          <td>
            {{
              prodUsaAtacado(produto)
                ? produto.preco_sem_politica_atacado
                : Number(produto.preco || 0) | formatMoney
            }}
          </td>
          <td>
            <div v-if="produto.idcombopromocional_cabecalho">
              {{ produto.preco | formatMoney }}
            </div>
            <div v-else>
              {{ retornaMenorPreco(produto) | formatMoney }}
            </div>
          </td>
          <td>
            <div v-if="!onlyview">
              {{
                (prodUsaAtacado(produto)
                  ? produto.preco_sem_politica_atacado
                  : produto.preco) - produto.precoatendente || 0 | formatMoney
              }}
            </div>
            <div v-else>
              {{
                ((prodUsaAtacado(produto)
                  ? produto.preco_sem_politica_atacado
                  : produto.preco) -
                  produto.precoatendente +
                  Number(produto.preco_do_desconto || 0))
                  | formatMoney
              }}
            </div>
          </td>
          <td>
            <div v-if="produto.precoatendente > 0">
              {{
                Number(produto.precoatendente * produto.quantidade)
                  | formatMoney
              }}
            </div>
            <div v-else>
              {{ Number(produto.preco * produto.quantidade) | formatMoney }}
            </div>
          </td>
        </tr>
        <tr v-for="produto in produtosOrdenados" :key="'combo-' + produto.id">
          <td colspan="10" v-if="produto.produtos">
            <div
              v-for="prod in produto.produtos"
              :key="prod.id"
              class="container-produtos-combo"
            >
              <span
                data-toggle="tooltip"
                title="Este produto faz parte de um Combo Promocional"
              >
                <i class="fab fa-product-hunt"></i>
              </span>
              <span
                @click="
                  buscarProduto(prod.idproduto, prod.idcadastroextraproduto)
                "
                v-if="!onlyview"
                >{{ prod.nome }}</span
              >
              <span v-else>{{ prod.nome }}</span>
              <span>{{ prod.quantidade }} UN</span>
              <span>{{ prod.preco | formatMoney }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-dialog v-model="dialogPesquisa" persistent width="80%">
      <v-card>
        <v-card-title>
          <span class="headline">Pesquisa Avançada de Produtos</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-row>
            <v-col>
              <FormAutocomplete
                v-model="idcategoria"
                :options="categorias"
                label="Categoria"
                :disabled="loading || localLoading"
              />
            </v-col>
            <v-col>
              <FormField
                v-model="search"
                label="Pesquisar produto"
                :disabled="loading || localLoading"
              />
            </v-col>
            <v-col cols="auto">
              <FormButton
                :loading="loading || localLoading"
                type="primario"
                @click="buscaAvancada"
              >
                Pesquisar
              </FormButton>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-simple-table
            class="text-start area-produtos"
            v-if="resultbusca && resultbusca.length > 0"
          >
            <thead>
              <tr>
                <th>Nome do produto</th>
                <th>Unitário</th>
                <th>Múltiplo</th>
                <th>Qtd</th>
                <th>Preço</th>
                <th>Original</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="produto in resultbusca" :key="produto.id">
                <td>
                  <v-icon
                    v-if="!(produto.meta_info && produto.meta_info.sem_estoque)"
                    class="mr-3"
                    color="success"
                    @click="adicionaProdutoAvancado(produto)"
                  >
                    fa-plus
                  </v-icon>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <v-icon color="red" class="mr-3" v-on="on"
                        >fa-exclamation-circle</v-icon
                      >
                    </template>
                    Produto indisponível
                  </v-tooltip>
                  <span
                    @click="
                      inforProduto(
                        produto.idproduto,
                        produto.idcadastroextraproduto
                      )
                    "
                  >
                    {{ produto.nome }}
                  </span>
                </td>
                <td>{{ produto.preco_original | formatMoney }}</td>
                <td>{{ produto.multiploincremento || 1 }}</td>
                <td>
                  <FormField
                    class="input-text mb-n5 mt-2"
                    label="Quantidade"
                    v-model="produto.quantidade"
                    :step="produto.granularidade || 1"
                    :min="0"
                    :disabled="
                      loading ||
                        localLoading ||
                        (produto.meta_info && produto.meta_info.sem_estoque)
                    "
                    @blur="granularidadeProduto(produto)"
                    @input="handlerInput(produto)"
                    typeField="number"
                  />
                </td>
                <td>{{ produto.preco | formatMoney }}</td>
                <td
                  v-if="
                    produto.precovendaatacado &&
                      produto.minvendaatacado &&
                      produto.quantidade * produto.multiploincremento >=
                        produto.minvendaatacado
                  "
                >
                  {{
                    produto.preco_sem_politica_atacado ||
                      produto.precovendaatacado ||
                      produto.preco_sem_politica_varejo ||
                      produto.preco_original | formatMoney
                  }}
                </td>
                <td v-else>
                  {{
                    produto.preco_sem_politica_varejo ||
                      produto.preco_original | formatMoney
                  }}
                </td>
                <td>
                  {{
                    (Number(produto.preco || 0) *
                      Number(produto.quantidade || 0))
                      | formatMoney
                  }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <FormButton
            :disabled="loading || localLoading"
            type="primario"
            text
            @click="dialogPesquisa = false"
          >
            Concluir
          </FormButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FormTags from "@/components/form/FormTags";
import FormButton from "@/components/form/FormButton";
import FormField from "@/components/form/FormField";
import FormAutocomplete from "@/components/form/FormAutocomplete";
import io from "socket.io-client";
import * as _ from "lodash";
import { uuid } from "uuidv4";
import ApiWeb from "../../../service/api-web";
import { mapGetters } from "vuex";
import {
  VENDA_MAIS_LOAD_CART,
  VENDA_MAIS_SAVE_CART,
  VENDA_MAIS_LOAD_PRICE,
  VENDA_MAIS_LOAD_PRODUTO,
  VENDA_MAIS_PRODUTOS_COPIA
} from "@/store/actions/vendaMais";
import { SETOR_FOLHA_LOAD } from "@/store/actions/setor";
import { PRODUTO_LOAD } from "@/store/actions/produto";
import { COMBO_PROMOCIONAL_LOAD_IMAGES } from "@/store/actions/comboPromocional";

export default {
  name: "NovoPedidoProdutos",
  components: { FormTags, FormButton, FormField, FormAutocomplete },
  props: {
    value: {
      type: Array,
      required: false,
      default: () => []
    },
    searchoption: {
      type: Object,
      required: false,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    onlyview: {
      type: Boolean,
      required: false,
      default: false
    },
    limparproduto: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    socketUrl: null,
    chatsocket: null,
    dialogPesquisa: false,
    selecionado: null,
    quantidade: 0,
    multiploincremento: 1,
    resultbusca: [],
    idcategoria: null,
    categorias: [],
    search: "",
    produtoDetalhes: null,
    comboDetalhes: null,
    alreadyChange: false,
    token: uuid(),
    changePrice: false,
    localLoading: false
  }),
  watch: {
    limparproduto() {
      if (this.limparproduto) {
        this.selecionado = "";
        this.limparproduto = false;
      }
    }
  },
  computed: {
    ...mapGetters(["getFornecedorId", "getFornecedorTag", "getProdutosCopia"]),
    endpointProdutos() {
      return `/api/v1/produtos/pedido-backoffice?idfornecedor=${this.getFornecedorId}&page=0&idcliente=${this.searchoption.idcliente}&idformapagamento=${this.searchoption.idformapagamento}&tipoEntrega=${this.searchoption.tipoEntrega}`;
    },
    enableStockControl() {
      return this.getFornecedorTag["enable-stock-control"];
    },
    step() {
      if (!this.selecionado) {
        return 1;
      }
      return this.selecionado.granularidade
        ? this.selecionado.granularidade
        : 1;
    },
    usaAtacado() {
      return (
        Number(_.get(this.selecionado, "precovendaatacado", 0)) &&
        Number(_.get(this.selecionado, "minvendaatacado", 0)) &&
        (this.multiploincremento || 1) * this.quantidade >=
          _.get(this.selecionado, "minvendaatacado", 1)
      );
    },
    casasDecimais() {
      return _.get(this.selecionado, "meta_info.quantidadeDecimais", 2);
    },
    produtoIndisponivel() {
      return _.get(this.selecionado, "meta_info.sem_estoque", false);
    },
    preco() {
      if (this.selecionado) {
        const temPolitica = this.selecionado.politicas.length > 0 || false;
        const preco_sem_politica = this.usaAtacado
          ? Number(_.get(this.selecionado, "preco_sem_politica_atacado", 0))
          : Number(_.get(this.selecionado, "preconf", 0));
        return preco_sem_politica > 0 && !temPolitica
          ? preco_sem_politica.toFixed(this.casasDecimais)
          : Number(_.get(this.selecionado, "preco", 0)).toFixed(
              this.casasDecimais
            );
      }
      return 0;
    },
    preco_minimo() {
      if (this.selecionado) {
        let precoVendaMais = Number(_.get(this.selecionado, "preco_minimo", 0));
        const precoPoliticaVendaMais =
          _.get(this.selecionado, "preco_com_politica_vendaplus", 0) *
          (this.selecionado.multiploincremento || 1).toFixed(
            this.casasDecimais
          );
        const precoNormal = this.usaAtacado
          ? _.get(this.selecionado, "precovendaatacado", 0)
          : _.get(this.selecionado, "preco_original", 0) *
            (this.selecionado.multiploincremento || 1);
        if (
          precoPoliticaVendaMais > 0 &&
          precoPoliticaVendaMais < precoNormal
        ) {
          return precoPoliticaVendaMais.toFixed(this.casasDecimais);
        } else {
          if (precoVendaMais < precoNormal) {
            return precoVendaMais.toFixed(this.casasDecimais);
          } else {
            return precoNormal.toFixed(this.casasDecimais);
          }
        }
      } else {
        return 0;
      }
    },
    preco_original() {
      if (this.selecionado) {
        let preco_sem_politica = this.usaAtacado
          ? Number(_.get(this.selecionado, "preco_sem_politica_atacado", 0))
          : Number(_.get(this.selecionado, "preco_sem_politica_varejo", 0));
        return preco_sem_politica > 0
          ? preco_sem_politica.toFixed(this.casasDecimais)
          : Number(_.get(this.selecionado, "preco_original", 0)).toFixed(
              this.casasDecimais
            );
      } else {
        return 0;
      }
    },
    preconf() {
      if (this.selecionado) {
        return Number(_.get(this.selecionado, "preconf", 0)).toFixed(
          this.casasDecimais
        );
      } else {
        return 0;
      }
    },
    preco_unitario() {
      if (this.selecionado) {
        const preco_original = Number(
          _.get(this.selecionado, "preco_original", 0)
        ).toFixed(this.casasDecimais);
        return Number(preco_original).toFixed(this.casasDecimais);
      } else {
        return 0;
      }
    },
    multiplo_incremento() {
      const multiplo = this.selecionado
        ? _.get(this.selecionado, "multiploincremento", 1)
        : 1;
      return multiplo || 1;
    },
    produtosOrdenados() {
      return this.ordenarProdutosPorNome(this.value);
    }
  },
  methods: {
    nomeProduto(produto) {
      if (!produto) return "";
      const nome = produto.idcombopromocional_cabecalho
        ? produto.nome_combo
        : produto.nome;
      return (nome || "").trim();
    },
    ordenarProdutosPorNome(produtos) {
      return [...(produtos || [])].sort((a, b) => {
        const cmp = this.nomeProduto(a).localeCompare(
          this.nomeProduto(b),
          "pt-BR",
          { sensitivity: "base" }
        );
        if (cmp !== 0) return cmp;
        return String(a.id).localeCompare(String(b.id));
      });
    },
    mesclarProdutosComValue(itens) {
      return (itens || []).map(item => {
        const existente = (this.value || []).find(v => v.id === item.id);
        return existente ? { ...existente, ...item } : item;
      });
    },
    getUrlSocket() {
      ApiWeb.v4.chat
        .getUrl()
        .then(resp => {
          const { socketUrl } = resp.data;

          if (!socketUrl) {
            this.$vueOnToast.pop(
              "error",
              "Erro ao buscar configuração do Socket"
            );
          } else {
            const idcliente = this.searchoption
              ? this.searchoption?.idcliente
              : "";

            this.socketUrl = socketUrl;

            if (io) {
              this.chatsocket = io(`${this.socketUrl}/atendimento`);
              this.chatsocket.on("connect", () => {
                this.chatsocket.emit("handshake", {
                  idcliente: idcliente,
                  idfornecedor: this.getFornecedorId
                });
              });
            }
          }
        })
        .catch(err => {
          this.$vueOnToast.pop("error", err);
        });
    },
    checandoGranularidade() {
      if (this.selecionado) {
        let quantidadeMinima =
          this.quantidade < this.selecionado.granularidade
            ? this.selecionado.granularidade
            : null;
        if (quantidadeMinima) {
          this.quantidade = quantidadeMinima || 1;
        } else {
          let nextMultipleGranularidade = Math.ceil(
            this.quantidade / this.selecionado.granularidade
          );
          this.quantidade =
            this.selecionado.granularidade * nextMultipleGranularidade || 1;
        }
      }
    },
    granularidadeProduto(prod) {
      if (prod) {
        if (prod.quantidade <= 0) {
          prod.quantidade = 0;
        } else {
          let nextMultipleGranularidade = Math.ceil(
            prod.quantidade / prod.granularidade
          );
          prod.quantidade = prod.granularidade * nextMultipleGranularidade || 0;
        }
      }
    },
    quantidadeProduto(prod) {
      const produtos = (this.value || []).map(v => ({
        ...v,
        precoatendente: v.precoatendente || v.preco
      }));
      let produtosCombo = [];
      let itens = (produtos || []).filter(it => {
        if (it.idcombopromocional_cabecalho) {
          produtosCombo = produtosCombo.concat(it.produtos);
          return false;
        }
        return true;
      });
      itens = itens.concat(produtosCombo);
      this.salvarCarrinho(itens, prod, null, true, "", false);
    },
    updatePrecoProduto(prod) {
      const minPreco = this.retornaMenorPreco(prod);
      if (!this.isPriceValid(prod.precoatendente, minPreco)) {
        prod.precoatendente = Number(minPreco).toFixed(this.casasDecimais);
        return;
      }

      prod.precoatendente =
        Number(prod.precoatendente).toFixed(this.casasDecimais) || 0;

      if (prod._precoOriginal == prod.precoatendente) {
        return;
      }

      const produtos = (this.value || []).map(v => ({
        ...v,
        precoatendente: v.precoatendente || v.preco
      }));

      this.$store.dispatch(VENDA_MAIS_PRODUTOS_COPIA, prod);

      this.salvarCarrinho(
        produtos,
        prod,
        null,
        true,
        "Preço do produto modificado",
        true
      );
    },
    blurPreco() {
      if (
        !this.isPriceValid(
          this.selecionado.preco,
          this.selecionado.preco_minimo
        )
      ) {
        this.changePrice = true;
        this.selecionado.preco = Number(
          this.selecionado.preco_minimo.toFixed(this.casasDecimais)
        );
      }
    },
    adicionarProduto() {
      if (!this.selecionado) {
        return;
      }
      let find = (this.value || []).find(item => {
        return this.selecionado.id === item.id;
      });
      if (find) {
        this.$vueOnToast.pop(
          "warning",
          "Este produto já está adicionado ao pedido"
        );
        return;
      }
      if (this.quantidade <= 0) {
        this.$vueOnToast.pop("warning", "A quantidade é obrigatória");
        return;
      }
      if (
        !this.isPriceValid(
          this.selecionado.preco,
          this.retornaMenorPreco(this.selecionado)
        )
      ) {
        return;
      }
      if (
        this.selecionado.maximo_disponivel !== null &&
        this.selecionado.maximo_disponivel < 1 &&
        this.enableStockControl
      ) {
        this.$vueOnToast.pop("warning", "Produto sem estoque");
        return;
      }
      const produtos = [
        ...(this.value || []),
        {
          ...this.selecionado,
          preco: this.preco,
          quantidade: this.quantidade
        }
      ];
      const prod = {
        ...this.selecionado,
        preco: this.preco,
        quantidade: this.quantidade || 1
      };
      this.$store.dispatch(VENDA_MAIS_PRODUTOS_COPIA, prod);
      this.salvarCarrinho(produtos, prod, null, true, "", false);
      this.selecionado = null;
      this.quantidade = 1;
      this.multiploincremento = 1;
    },
    adicionaProdutoAvancado(produto) {
      let find = (this.value || []).find(item => {
        return produto.id === item.id;
      });
      if (find) {
        this.$vueOnToast.pop(
          "warning",
          "Este produto já está adicionado ao pedido"
        );
        return;
      }
      if (produto.quantidade <= 0) {
        this.$vueOnToast.pop("warning", "A quantidade é obrigatória");
        return;
      }
      this.resultbusca = (this.resultbusca || []).filter(item => {
        return item.id != produto.id;
      });
      const produtos = [
        ...(this.value || []),
        {
          ...produto
        }
      ];
      const prod = {
        ...this.selecionado,
        preco: this.preco,
        quantidade: this.quantidade || 1
      };
      this.salvarCarrinho(produtos, prod, null, true, "", false);
    },
    removeProduct(id) {
      const produtoExcluido = (this.value || []).filter(item => {
        return item.id == id;
      })[0];
      const filtered = (this.value || []).filter(item => {
        return item.id !== id;
      });
      this.salvarCarrinho(filtered, null, produtoExcluido, true, "", true);
    },
    abrirBuscaAvancada() {
      this.resultbusca = [];
      this.buscarSetores();
      this.dialogPesquisa = true;
    },
    buscaAvancada() {
      this.localLoading = true;
      const data = {
        search: this.search,
        idcategoria: this.idcategoria || "",
        idcliente: _.get(this.searchoption, "idcliente", ""),
        idformapagamento: _.get(this.searchoption, "idformapagamento", ""),
        tipoEntrega: _.get(this.searchoption, "tipoEntrega", "")
      };
      this.$store
        .dispatch(VENDA_MAIS_LOAD_PRODUTO, data)
        .then(data => {
          this.resultbusca = data.map(item => ({
            ...item,
            quantidade: 0
          }));
          this.localLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao buscar produtos");
          this.localLoading = false;
        });
    },
    buscarProduto(idproduto, idcadastroextraproduto) {
      this.localLoading = true;
      this.$store
        .dispatch(PRODUTO_LOAD, { idproduto, idcadastroextraproduto })
        .then(produto => {
          this.produtoDetalhes = produto;
          this.localLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop(
            "error",
            "Falha ao buscar informações sobre o produto"
          );
          this.localLoading = false;
        });
    },
    buscarImagemCombo(combo) {
      this.localLoading = true;
      this.$store
        .dispatch(COMBO_PROMOCIONAL_LOAD_IMAGES, {
          id: combo.idcombopromocional_cabecalho
        })
        .then(comboImagens => {
          const image_url = _.get(comboImagens, "imagens[0].mediumSize", "");
          this.comboDetalhes = {
            ...combo,
            image_url
          };
          this.localLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop(
            "error",
            "Falha ao buscar informações sobre o combo"
          );
          this.localLoading = false;
        });
    },
    prodUsaAtacado(produto) {
      return (
        Number(produto.precovendaatacado || 0) &&
        Number(produto.minvendaatacado || 0) &&
        (produto.multiploincremento || 1) * produto.quantidade >=
          (produto.minvendaatacado || 1)
      );
    },
    retornaMenorPreco(produto) {
      if (
        produto.preco_sem_politica_atacado > 0 &&
        produto.preco_sem_politica_atacado < produto.preco &&
        this.prodUsaAtacado(produto)
      ) {
        return produto.preco_sem_politica_atacado;
      } else if (
        produto.preco_com_politica > 0 &&
        produto.preco_com_politica * (produto.multiploincremento || 1) <
          produto.preco &&
        produto.preco_com_politica * (produto.multiploincremento || 1) <
          produto.preco_com_politica_vendaplus *
            (produto.multiploincremento || 1)
      ) {
        return produto.preco_com_politica * (produto.multiploincremento || 1);
      } else if (
        produto.preco_com_politica_vendaplus > 0 &&
        produto.preco_com_politica_vendaplus *
          (produto.multiploincremento || 1) <
          produto.preco
      ) {
        return (
          produto.preco_com_politica_vendaplus *
          (produto.multiploincremento || 1)
        );
      } else {
        return produto.preco;
      }
    },
    salvarCarrinho(
      produtos,
      produtoAlterado,
      produtoExcluido,
      buscarCarrinho = false,
      msg = "",
      emit = false
    ) {
      this.localLoading = true;
      const data = {
        token: this.token,
        idcliente: _.get(this.searchoption, "idcliente", ""),
        produtosSelecionados: produtos.map(produtoOriginal => {
          const produto = { ...produtoOriginal };

          const produtoCopia = this.getProdutosCopia.find(
            produtoCopia => produtoCopia.id === produto.id
          );

          const precoProduto = Number(produto.precoatendente);
          const precoCopia =
            produtoCopia && produtoCopia.precoatendente
              ? Number(produtoCopia.precoatendente)
              : null;
          const precoOriginal = produto.preco_original
            ? produto.preco_original * (produto.multiploincremento || 1)
            : null;
          const precoBase =
            precoProduto ||
            produto.preco_sem_fator ||
            precoOriginal ||
            precoCopia ||
            Number(produto.preco) ||
            0;
          const precoFinal = precoCopia !== null ? precoCopia : precoBase;
          const produtoSendoAlterado =
            produtoAlterado && produto.id === produtoAlterado.id;
          const quantidadeInalterada =
            produto._quantidadeOriginal == null ||
            produto._quantidadeOriginal == produto.quantidade;
          const quantidadeAlterada =
            produto._quantidadeOriginal != null &&
            produto._quantidadeOriginal != produto.quantidade;
          const precoAlterado = produto._precoOriginal != precoFinal;

          if (produtoSendoAlterado && precoAlterado && quantidadeInalterada) {
            produto.precoatendente = precoFinal;
          } else if (
            produtoSendoAlterado &&
            quantidadeAlterada &&
            produto.precoatendente == precoFinal
          ) {
            produto.precoatendente = produto.preco_sem_fator;
          } else {
            produto.precoatendente = precoFinal;
          }
          return {
            ...produto,
            precoatendente: produto.precoatendente || 0
          };
        }),
        idformapagamento: _.get(this.searchoption, "idformapagamento", "")
      };
      this.$store
        .dispatch(VENDA_MAIS_SAVE_CART, data)
        .then(data => {
          const produtoCarrinho = data ? data?.itens : [];

          if (data.status === "success") {
            if (emit) {
              this.$emit(
                "input",
                this.ordenarProdutosPorNome(
                  this.mesclarProdutosComValue(data.itens)
                )
              );
            }
            if (io) {
              this.chatsocket.emit("block-cart", true);
              if (produtoExcluido) {
                this.chatsocket.emit("remove-product-cart", produtoExcluido);
              }
              if (produtoAlterado) {
                const produtoAlteradoCarrinho = produtoCarrinho.find(
                  produto => produto.id === produtoAlterado.id
                );

                this.chatsocket.emit(
                  "change-product-cart",
                  produtoAlteradoCarrinho
                );
              }
              if (buscarCarrinho) {
                this.buscarCarrinho();
              }
              if (msg) {
                this.$vueOnToast.pop("success", msg);
              }
            }
          }
          this.localLoading = false;
        })
        .catch(() => {
          this.localLoading = false;
        });
    },
    buscarCarrinho() {
      this.localLoading = true;
      const data = {
        token: this.token,
        idcliente: _.get(this.searchoption, "idcliente", ""),
        idformapagamento: _.get(this.searchoption, "idformapagamento", ""),
        idtipoassinatura: "",
        tipoEntrega: _.get(this.searchoption, "tipoEntrega", ""),
        vendaMais: true
      };
      this.$store
        .dispatch(VENDA_MAIS_LOAD_CART, data)
        .then(data => {
          if (data.status === "success") {
            data.dados.forEach(d => {
              if (!d.precoatendente) {
                d.precoatendente = d.preco;
              }

              d.precoatendente = d.precoatendente.toFixed(2);
              d._precoOriginal = d.precoatendente;
              d._quantidadeOriginal = d.quantidade;
            });
            this.$emit(
              "input",
              this.ordenarProdutosPorNome(
                this.mesclarProdutosComValue(
                  data.dados.filter(prod => prod.quantidade > 0)
                )
              )
            );
          }
          this.localLoading = false;
        })
        .catch(() => {
          this.localLoading = false;
        });
    },
    buscarPreco() {
      if (!this.selecionado) return;
      this.localLoading = true;
      const data = {
        produtos: [this.selecionado],
        idcliente: _.get(this.searchoption, "idcliente", ""),
        idformapagamento: _.get(this.searchoption, "idformapagamento", ""),
        idfornecedor: this.getFornecedorId,
        menorPreco: true,
        tipoentrega: _.get(this.searchoption, "tipoEntrega", "")
      };
      this.$store
        .dispatch(VENDA_MAIS_LOAD_PRICE, data)
        .then(data => {
          let p = data[0];
          this.quantidade = this.selecionado.granularidade;
          this.selecionado = {
            ...this.selecionado,
            preco: p.preco,
            preco_minimo: p.preco,
            preco_com_politica_vendaplus: p.preco_com_politica_vendaplus
          };
          this.multiploincremento = this.selecionado.multiploincremento;
          this.checandoGranularidade();
          this.alreadyChange = false;
          this.localLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao buscar custo mínimo");
          this.quantidade = this.selecionado.granularidade;
          this.multiploincremento = this.selecionado.multiploincremento;
          this.checandoGranularidade();
          this.alreadyChange = false;
          this.localLoading = false;
        });
    },
    buscarSetores() {
      this.$store
        .dispatch(SETOR_FOLHA_LOAD)
        .then(data => {
          this.categorias = data.map(c => {
            return {
              ...c,
              text: c.rotulo,
              value: c.id
            };
          });
          this.categorias.unshift({ text: "Todas categorias", value: null });
          this.localLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao buscar categorias");
          this.localLoading = false;
        });
    },
    maxPorProduto(produto) {
      if (!produto) return;
      const quantidadeAtual =
        produto.quantidade > 0 ? produto.quantidade : this.quantidade;
      const multiploincremento = produto.multiploincremento
        ? produto.multiploincremento
        : 1;
      const maxporpedido = produto.maxporpedido;
      const maximodisponivel =
        produto.maximo_disponivel && this.enableStockControl
          ? Math.floor(Number(produto.maximo_disponivel / multiploincremento))
          : null;
      let trava = false;
      let maxQuantidade = 0;
      if (maximodisponivel && maxporpedido) {
        maxQuantidade = _.min([maximodisponivel, maxporpedido]);
      } else if (maximodisponivel) {
        maxQuantidade = maximodisponivel;
      } else if (maxporpedido) {
        maxQuantidade = maxporpedido;
      }
      const notUpdate = maxQuantidade && quantidadeAtual > maxQuantidade;
      if (notUpdate) {
        produto.quantidade > 0
          ? (produto.quantidade = maxQuantidade)
          : (this.quantidade = maxQuantidade);
        this.$vueOnToast.pop(
          "warning",
          "Não foi possível alterar a quantidade desse produto!, Máximo disponível do produto alcançado!"
        );
        return (trava = true);
      } else {
        trava = false;
      }
      return trava;
    },
    handlerInput(produto, salvar = false) {
      if (produto.quantidade == produto._quantidadeOriginal) {
        return;
      }
      this.maxPorProduto(produto.idproduto ? produto : this.selecionado);

      if (salvar) {
        this.quantidadeProduto(produto);
      }
    },
    isPriceValid(preco, precoMinimo) {
      const precoArrendondado = Number(Number(preco).toFixed(2));
      const minPreco = Number(Number(precoMinimo).toFixed(2));
      if (precoArrendondado >= minPreco) {
        return true;
      }

      this.$vueOnToast.pop(
        "warning",
        `O Preço está abaixo do preço mínimo. R$ ${minPreco}`
      );
      return false;
    },
    precoProduto(produto) {
      const produtoAtual = this.getProdutosCopia.find(
        product => product.id === produto.id
      );

      const precoProduto = Number(produto.precoatendente);

      return (
        Number(
          produtoAtual
            ? produtoAtual.precoatendente || precoProduto
            : precoProduto || produto.preco
        ) || 0
      ).toFixed(this.casasDecimais);
    },
    setPrecoAtendente(produto, valor) {
      if (produto) {
        produto.precoatendente = valor;
      }
    }
  },
  created() {
    this.getUrlSocket();
  }
};
</script>

<style>
.input-text {
  max-width: 180px;
}
.area-produtos {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
